export class AuthUser {
    username: string;

    constructor(username: string) {
        this.username = username;
    }

}
